import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { AdminAuthService } from './admin-auth.service';

/**
 * Ensures all outgoing API requests include the Bearer token when the user or admin is logged in.
 * Admin routes (/api/admin/) use the admin token; other routes use the user token.
 * On 401 responses, clears auth and redirects (welcome for user, admin/login for admin).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const adminAuth = inject(AdminAuthService);
  const router = inject(Router);
  const isAdminRequest = req.url.includes('/api/admin/');
  const token = isAdminRequest ? adminAuth.getToken() : auth.getUser()?.token;

  if (token) {
    const cloned = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next(cloned).pipe(
      catchError((err) => {
        if (err?.status === 401) {
          if (isAdminRequest) {
            adminAuth.clearToken();
            router.navigate(['/admin/login']);
          } else {
            auth.signOff();
            router.navigate(['/welcome']);
          }
        }
        return throwError(() => err);
      })
    );
  }

  return next(req);
};
